import { securedAxiosInstance } from '@/backend/axios'
import Indicator from '@/lib/indicator'

const downloadCSV = (entryIds) => {
  Indicator.emitShow()
  securedAxiosInstance.post('/entry/download/entries/resume/csv', [...entryIds]).then(response => {
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
    const blob = new Blob([bom, response.data], { type: 'text/csv' })
    _triggerDownload(blob, 'resume.csv')
  }).finally(() => {
    Indicator.emitHide()
  })
}

const downloadPDF = (entryIds) => {
  Indicator.emitShow()
  securedAxiosInstance.post('/entry/download/entries/resume/pdf', [...entryIds]).then((response) => {
    _triggerDownloadUrl(response.data)
  }).finally(() => {
    Indicator.emitHide()
  })
}

const downloadUrl = (url) => {
  _triggerDownloadUrl(url)
}

function _triggerDownloadUrl (url) {
  const link = document.createElement('a')
  link.download = '' // S3のDLの場合、ファイル名を指定しても無視されるため省略
  link.href = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

function _triggerDownload (blob, fileName) {
  const link = document.createElement('a')
  link.download = fileName

  if (window.navigator.msSaveBlob) {
    // for IE
    window.navigator.msSaveBlob(blob, fileName)
  } else {
    link.href = window.URL.createObjectURL(blob)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

export {
  downloadCSV,
  downloadPDF,
  downloadUrl
}
